export const SESSION_EXPIRY_KEY = 'auth_expires_at';

const AUTH_STORAGE_KEYS = [
  'token',
  'otp_verified',
  'is_aic_one_login',
  'auth_redirect_reason',
  'auth_expires_at',
  'current_user_id',
  'current_lead_id',
  'current_role',
  'current_lead_name',
  'current_project_name',
  'user_id',
  'user_role',
  'display_name',
  'project_id',
  'company_name',
  'entity_type_id',
  'entity_profile_id',
  'lead_id',
  'lead_name',
  'role_type',
  'current_platform',
  'first_time_login',
  'profile_role_form_id',
];

function clear_storage_area(storage) {
  for (const key of AUTH_STORAGE_KEYS) {
    storage.removeItem(key);
  }
}

export function clear_auth_storage() {
  if (typeof window === 'undefined') {
    return;
  }

  clear_storage_area(window.sessionStorage);
  clear_storage_area(window.localStorage);
}

export function has_auth_context(config = {}) {
  const headers = config.headers || {};
  return Boolean(
    sessionStorage.getItem('token')
    || headers.Authorization
    || headers.authorization
  );
}
